
import {Component, Prop} from "vue-property-decorator";
import {
    HCCValidator,
    HcPageModel,
    IHCCRule,
    IHCCValidator,
    PhoneNumberCzRule,
    PhoneNumberSkRule
} from "@dev/hc-components";
import TemplateOptions from "@/module/main/page/TemplateOptionsEnum";
import Culture from "@/module/main/page/CultureEnum";
import IBlock1 from "@/module/main/model/applicationForm/IBlock1";
import PlatformUsedType
    from "@/module/main/dto/financing-v3/PlatformUsedTypeEnum";
import {EnumUtil} from "@/app";
import FinancedSubjectType from "@/module/main/dto/FinancedSubjectTypeEnum";
import YesNo from "@/app/service/YesNoEnum";

@Component
export default class Block1 extends HcPageModel {
    @Prop({type: Object}) public value!: IBlock1;
    @Prop({type: String}) public culture!: Culture;
    @Prop({type: String}) public template!: TemplateOptions;

    protected pageName: string = "block1";
    private phoneNumberValidator: IHCCValidator = this.getPhoneNumberValidator();

    private getPhoneNumberValidator(): IHCCValidator {
        return new HCCValidator(
            this.getPhoneNumberRules(),
            this.$localize("pg-phone-number-format-error-msg"),
            false,
            false
        );
    }

    private getPhoneNumberRules(): IHCCRule[] {
        return this.template === TemplateOptions.SK
            ? [new PhoneNumberSkRule(this.$localize("mobile-phone-format-error-msg"))]
            : [new PhoneNumberCzRule(this.$localize("mobile-phone-format-error-msg"))];
    }

    private get platformUsedData(): object[] {
        return EnumUtil.createSelectDataFromEnum(PlatformUsedType, "PlatformUsedType");
    }

    private get consentFinancialDispoData(): object[] {
        return EnumUtil.createSelectDataFromEnum(YesNo, "YesNo", true);
    }

    private get isWallet(): boolean
    {
        let financedSubjectType = FinancedSubjectType[this.$store.getters["main/getFinancedSubjectType"] as FinancedSubjectType];

        return financedSubjectType === FinancedSubjectType.WALLET;
    }

    private get isWalletWithOrder()
    {
        return this.isWallet && this.$store.getters["main/getWalletWithOrder"] === YesNo.YES;
    }
}
